export const BloodConfigActions = {
    UPDATE_YTOP : "UPDATE_YTOP",
    UPDATE_YBOTTOM : "UPDATE_YBOTTOM",
    UPDATE_COUNT_SLOT_WISE: "UPDATE_COUNT_SLOT_WISE",
} 